import { AxiosResponse } from 'axios';
import { MARKETPLACE_SPECIMEN_ENDPOINTS } from '../constants/apiEndpoints';
import { ODataParams } from '../types/interfaces';
import { PagedResponse, StandardParams } from '../types/interfaces/apiParams.interfaces';
import { MarketplacePriceRange, MarketPlaceRequest, MarketPlaceSpecimenResponse } from '../types/interfaces/marketPlace.interfaces';
import { appContextDelete, appContextGet, appContextPost, appContextPut } from './httpCommon/appAxios.service';
import qs from 'qs';

export const addToMarketplace = (accountId: number, specimens: MarketPlaceRequest[]): Promise<AxiosResponse<number, any>> => {
  return appContextPost(MARKETPLACE_SPECIMEN_ENDPOINTS.MARKETPLACE_SPECIMEN, specimens, { accountId });
};

export const getMarketplaceSpecimens = (
  params: StandardParams
): Promise<AxiosResponse<MarketPlaceSpecimenResponse[]>> => {
  return appContextGet(MARKETPLACE_SPECIMEN_ENDPOINTS.MARKETPLACE_SPECIMEN, params);
};

export const getMarketplaceSpecimenById = (
  marketPlaceSpecimenId: number,
  params?: { include?: string },
): Promise<AxiosResponse<MarketPlaceSpecimenResponse, any>> => {
  return appContextGet(`${MARKETPLACE_SPECIMEN_ENDPOINTS.MARKETPLACE_SPECIMEN}/${marketPlaceSpecimenId}`, params);
};

export const updateMarketplaceListing = (
  marketPlaceSpecimenId: number,
  payload: MarketPlaceRequest,
): Promise<AxiosResponse<void>> => {
  return appContextPut(`${MARKETPLACE_SPECIMEN_ENDPOINTS.MARKETPLACE_SPECIMEN}/${marketPlaceSpecimenId}`, payload);
};

export const removeMarketplaceListing = (marketPlaceSpecimenId: number, reason: string): Promise<AxiosResponse<boolean>> => {
  return appContextDelete(`${MARKETPLACE_SPECIMEN_ENDPOINTS.MARKETPLACE_SPECIMEN}/${marketPlaceSpecimenId}`, { reasonForDelete: reason });
};

export const getMarketPlaceSpecimenUnitsCount = (params: {
  accountId: number;
  animalId: number;
}): Promise<AxiosResponse<number | { marketplaceSpecimenCount?: number }>> => {
  return appContextGet(MARKETPLACE_SPECIMEN_ENDPOINTS.MARKETPLACE_SPECIMEN_UNITS_COUNT, params);
};

export const getMarketplaceSpecimensOData = (
  params?: ODataParams,
  prioritizeSponsored?: boolean,
): Promise<AxiosResponse<MarketPlaceSpecimenResponse[] | PagedResponse<MarketPlaceSpecimenResponse>, any>> => {
  const paramsWithSponsoredPriority = prioritizeSponsored == null ? params : { ...params, prioritizeSponsored };
  return appContextGet(
    `${MARKETPLACE_SPECIMEN_ENDPOINTS.MARKETPLACE_SPECIMEN}${MARKETPLACE_SPECIMEN_ENDPOINTS.ODATA}`,
    undefined,
    {
    paramsSerializer: (p: Record<string, any>) => qs.stringify(p, { arrayFormat: 'repeat' }),
    params: paramsWithSponsoredPriority,
    },
  );
};

export const downloadMarketplaceListingsReport = (payload?: {}, query?: ODataParams): Promise<AxiosResponse<any, any>> => {
  return appContextPost(MARKETPLACE_SPECIMEN_ENDPOINTS.MARKETPLACE_SPECIMEN_EXPORT, payload, query, { responseType: 'blob' });
};

export const getMarketplacePriceRange = (): Promise<AxiosResponse<MarketplacePriceRange>> => {
  return appContextGet(MARKETPLACE_SPECIMEN_ENDPOINTS.MARKETPLACE_SPECIMEN_PRICE_RANGE);
};
